import {Auth0ContextInterface, useAuth0} from "@auth0/auth0-react";
import {useAuth} from "@frontegg/react";
import {environment} from "../env";
import {AuthState} from "@frontegg/redux-store";
import {NavigateFunction} from "react-router/dist/development";

export type MithraAuthContext = {
    auth0: Auth0ContextInterface | null;
    frontEgg: AuthState | null;
}

/**
 * Intend to navigate to a new page
 */
export type NavigationIntent = {
    navigate: NavigateFunction // See react-router useNavigate()
    route: `/${string}` // Target to navigate to (String that starts with '/')
}

/**
 * Small wrapper to combine the two authentication contexts
 */
export function useMithraAuthContext(): MithraAuthContext {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const auth0 = environment.hasAuth0 ? useAuth0() : null;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const frontEgg = environment.hasFrontegg ? useAuth() : null;
    return {auth0, frontEgg};
}
